import Vue from 'vue';
import {
    getUnbindReservation
} from '../../../services/crmService/reservationService';

import {
    getCustomerReservationTimeList,
    getCustomerReservationTypes,
    getReservationStores,
    storeCustomerReservation
} from '../../../services/personnelService/reservationService';

// initial state
// state 必為模組區域變數，取時需 store.state.auth.user
// 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
// 區域使用時值需加上 name
const state = {
    reservations: [],
    pagination: {
        current_page: 0,
        per_page: 5
    },
    reservationsTypeList: [],
    reservationTimeList: [],
    reservationStores: []
};

// getters
const getters = {};

// actions
const actions = {
    // 取得預約列表
    async getUnbindReservationHandler({ commit }, statusInfo) {
        const data = await getUnbindReservation(statusInfo);
        commit('setReservations', data);
    },
    // 取得預約種類
    async getCustomerReservationTypesHandler({ commit }, formData) {
        const data = await getCustomerReservationTypes(formData);
        commit('setReservationsTypeList', data.data);
    },
    // 拿取可預約時間列表
    async getReservationTimeListHandler({ commit }, formData) {
        const data = await getCustomerReservationTimeList(formData);
        commit('setReservationTimeList', data.data);
        return data.data;
    },
    // 拿取店舖
    async getReservationStoresHandler({ commit }) {
        const data = await getReservationStores();
        commit('setReservationStores', data.data);
    },
    // 送出預約
    async storeReservationHandler({}, sendInfo) {
        await storeCustomerReservation(sendInfo);
    }
};

// mutations
const mutations = {
    setReservations(state, data) {
        Vue.set(state, 'reservations', state.reservations.concat(data.data.reservations));
        Vue.set(state, 'pagination', data.pagination);
    },
    setReservationsTypeList(state, data) {
        Vue.set(state, 'reservationsTypeList', data.options);
    },
    // 重置所有資料
    resetHandler(state) {
        Vue.set(state, 'reservations', []);
        Vue.set(state, 'pagination', {
            current_page: 0,
            per_page: 5
        });
    },
    setReservationTimeList(state, data) {
        Vue.set(state, 'reservationTimeList', data.options);
    },
    setReservationStores(state, data) {
        Vue.set(state, 'reservationStores', data.options);
    },
    resetReservationTimeListHandler(state) {
        Vue.set(state, 'reservationTimeList', []);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
